// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1Fx1b","label":"LabeledBox_label__2ob2a"};